module.exports = __webpack_public_path__ + "static/img/y43.857e118.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y43.png
// module id = HXp4
// module chunks = 1